import { cn } from '../../lib/cn.js'

/**
 * The shape of what is coming, not a spinner.
 *
 * *"Loading shows the shape of the page in skeletons rather than a spinner, so the
 * layout does not jump when it arrives."* A spinner says something is happening; a
 * skeleton says what it will be, and the page does not move when it lands.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div aria-hidden className={cn('animate-pulse rounded-md bg-sunk', className)} {...props} />
  )
}

/** A block of lines, for a paragraph or a cell that has not arrived. */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton
          key={i}
          className="h-4"
          /* The last line short, because prose does not end flush. */
          style={{ width: i === lines - 1 ? '60%' : '100%' }}
        />
      ))}
    </div>
  )
}
